import { render, staticRenderFns } from "./createBulkPromotion.vue?vue&type=template&id=66d1e0e0&scoped=true&"
import script from "./createBulkPromotion.vue?vue&type=script&lang=js&"
export * from "./createBulkPromotion.vue?vue&type=script&lang=js&"
import style0 from "./createBulkPromotion.vue?vue&type=style&index=0&id=66d1e0e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d1e0e0",
  null
  
)

export default component.exports